import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'lib/utils';

/**
 * 시맨틱 뱃지. DESIGN.md §7: pill 모양, 12px, 배경은 시맨틱 색 -50~100 톤,
 * 텍스트는 -700 톤. 그림자/transform 없음.
 */
const badgeVariants = cva(
    'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium transition-colors',
    {
        variants: {
            variant: {
                default: 'bg-navy-50 text-primary',
                secondary: 'bg-neutral-100 text-neutral-700',
                outline: 'border border-border text-neutral-700 bg-transparent',
                // 배경 = 시맨틱 토큰 10% (DESIGN.md §7) — Tailwind 기본 팔레트(green-50 등) 사용 안 함
                success: 'bg-success/10 text-success',
                warning: 'bg-warning/10 text-warning',
                danger: 'bg-destructive/10 text-destructive',
                info: 'bg-info/10 text-info',
                solid: 'bg-primary text-primary-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLSpanElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <span className={cn(badgeVariants({ variant }), className)} {...props} />
    );
}

export { Badge, badgeVariants };
